import { OBJECT_DEFAULT, TEXT_TRIM_REGEX } from 'constants';
import { Fade } from 'helpers/animation';
import useFormInput from 'hooks/form/useFormInput';
import useLang from 'hooks/useLang';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import { paragraph500Mixin } from 'styles';

const NAME_MAX_LENGTH = 70;

const FormInputNameValidation = ({
  ref,
  field,
  information,
  setInformation,
  validation,
  setValidation,
  checkFormInputValidation,
  rootStyles = OBJECT_DEFAULT,
}) => {
  const { t } = useLang();

  const {
    setInformationFormInput,
    setValidationFormInput,
    getValueTrimAll,
    FormLabel,
    FormControlFeedback,
  } = useFormInput(field);

  const handleOnChange = (e) => {
    const { value, name } = e.target;

    if (!value) {
      let newInformation = setInformationFormInput({
        value: '',
        information,
        setInformation,
      });
      setValidationFormInput({
        validation,
        setValidation,
        checkFormInputValidation: () =>
          checkFormInputValidation(
            newInformation[name],
            field,
            newInformation,
            validation
          ),
      });
      return;
    }

    if (value?.length > NAME_MAX_LENGTH) return;

    let newInformation = setInformationFormInput({
      value,
      information,
      setInformation,
    });

    setValidationFormInput({
      validation,
      setValidation,
      checkFormInputValidation: () =>
        checkFormInputValidation(
          newInformation[name],
          field,
          newInformation,
          validation
        ),
    });
  };
  const handleOnBlur = (e) => {
    const { value } = e.target;

    if (!value) return;
    if (validation?.[field.name]) return;

    setInformationFormInput({
      value: getValueTrimAll(value, true, TEXT_TRIM_REGEX),
      information,
      setInformation,
    });
  };

  return (
    <FormGroupStyled style={rootStyles || {}}>
      <FormLabel styles={{ marginBottom: '4px' }} />
      <FormControl
        ref={ref}
        type={field.type}
        name={field.name}
        value={information ? information[field.name] : ''}
        placeholder={t(field.placeholder)}
        isInvalid={validation[field.name]}
        onChange={handleOnChange}
        onBlur={handleOnBlur}
        readOnly={field?.isReadOnly}
      />
      <FormControlFeedback
        value={t(validation[field.name])}
        validationStyles={{ position: 'unset' }}
      />
    </FormGroupStyled>
  );
};

const FormGroupStyled = styled(Form.Group)`
  ${Fade};
  position: relative;
`;

const FormControl = styled(Form.Control)`
  ${paragraph500Mixin};
  text-transform: uppercase;
  height: 44px;
  border: 1px solid var(--ds-c-grey-light);
  border-radius: 8px;
  padding-inline: 10px;
  background: var(--ds-c-white);

  &:focus {
    border: 1px solid var(--ds-c-grey-dark) !important;
    outline: none !important;
    box-shadow: none !important;
  }

  &:invalid,
  &:invalid:focus {
  }
  &.is-invalid {
    border: 1px solid var(--ds-c-red) !important;
    outline: none !important;
    box-shadow: none !important;
    background-image: none !important;
    padding-inline: 10px !important;
  }

  &[readonly] {
    border: none !important;
  }

  &::placeholder {
    ${paragraph500Mixin};
    color: var(--ds-c-blue-disabled) !important;
    text-transform: uppercase;
  }
`;

export default FormInputNameValidation;
